import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import BaseSelect from "components/baseSelect";

const FormikEmergencyContact = ({
  errors,
  touched,
  handleChange,
  values,
  element,
  removeEmergencyContact,
  opions,
  InputMask,
  index,
}) => {
  const onRemoveEmergencyContact = () => removeEmergencyContact(element.id);

  const alignEnd = {
    display: "flex",
    alinItems: "flex-end",
  };

  const alignCenter = {
    displa: "flex",
    alignItems: "center",
  };

  return (
    <>
      <Form.Group as={Col} md="3" controlId={"validationFormik_" + element.id}>
        <Form.Label> Nombre</Form.Label>
        <Form.Control
          type="text"
          name={`firstName_${element.id}`}
          placeholder="John Archie"
          value={values[`firstName_${element.id}`]}
          onChange={handleChange}
          isInvalid={!!errors[`firstName_${element.id}`]}
        />
      </Form.Group>

      <Form.Group as={Col} md="3" controlId={"validationFormik_" + element.id}>
        <Form.Label> Número de teléfono</Form.Label>
        <Form.Control
          as={InputMask}
          mask="(999) 999-9999"
          type="text"
          name={`phoneNumber_${element.id}`}
          placeholder="(829) 000-0000"
          value={values[`phoneNumber_${element.id}`]}
          onChange={handleChange}
        />
      </Form.Group>

      <BaseSelect
        md={3}
        errors={errors}
        touched={touched}
        handleChange={handleChange}
        values={values}
        label={"Relación"}
        name={`kinship_${element.id}`}
        url={"Parentesco"}
      />
    </>
  );
};

export default FormikEmergencyContact;
